import styled from 'styled-components';

import {
  colorAccent250,
  colorBlack200,
  colorBlack900,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryDesktopMin,
  mediaQueryTabletSmallMin,
} from '@/styleUtils';

export const Block = styled.div`
  background-color: ${colorWhite};
  border-radius: 12px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media ${mediaQueryDesktopMin} {
    padding: 24px;
  }
`;

export const ProductTitle = styled.h1`
  color: ${colorBlack900};
  font: 700 32px/40px ${fontFamilySecondary};
`;

export const ProductDetails = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;

  @media ${mediaQueryTabletSmallMin} {
    gap: 12px;
    flex-wrap: nowrap;
  }
`;

export const ProductDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background-color: ${colorAccent250};

  &:not(:first-child) {
    width: calc(50% - 4px);

    @media ${mediaQueryTabletSmallMin} {
      width: 100%;
    }
  }
`;

export const ProductDetailValue = styled.strong`
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: ${colorBlack900};
  font: 700 24px/32px ${fontFamilyPrimary};
  white-space: nowrap;

  span {
    font: 700 12px/24px ${fontFamilyPrimary};
    width: max-content;
  }
`;

export const ProductDetailCaption = styled.span`
  color: ${colorBlack200};
  font: 400 12px/16px ${fontFamilyPrimary};
  width: max-content;
`;
